// extracted by mini-css-extract-plugin
module.exports = {"Ratio":"styles_Ratio__uv4WO","children":"styles_children__pwOrA"};